
/**
 * Truncates array of any items down to the nearest given multiple. Used to "round
 * down" an array, for example when trying to neatly display a grid of a given size.
 *
 * If the given array has fewer items than the given multiple, this helper returns the
 * array with no changes.
 */
export const truncateToMultiple = <T>(arr: T[], multiple: number): T[] => {
  const desiredLength = Math.floor(arr.length / multiple) * multiple;
  return arr.length > multiple
    ? arr.slice(0, desiredLength)
    : arr;
};
